import { Component, EventEmitter, Input, OnDestroy, OnChanges, Output } from '@angular/core';
import { DataObject } from '../../../../../../models/data-object.models';

@Component({
  selector: 'sp-opportunity',
  templateUrl: './opportunity.component.html',
  styleUrls: ['./opportunity.component.scss'],
  standalone: false,
})
export class OpportunityComponent implements OnChanges, OnDestroy {
  @Input() isConfidential: boolean = false;
  @Input() isCIQDown: boolean = false;
  @Input() hasAccessToOpportunities: boolean = true;
  @Input() opportunities: DataObject[] = [];
  @Output() navigate: EventEmitter<any> = new EventEmitter();

  public message: string = '';

  ngOnChanges() {
    this.message = this.checkForMessages();
  }

  // returns validation messages if any
  checkForMessages(): string {
    if (this.isConfidential) {
      return 'confidentialOpportunities';
    }
    if (this.isCIQDown) {
      return 'ciqDown';
    }
    if (!this.hasAccessToOpportunities) {
      return 'noOpportunityAccessMIQ';
    }
    if (this.opportunities?.length === 0) {
      return 'noOpportunitiesLinked';
    }
    if (this.opportunities?.length > 0) {
      const confOpportunitiesCount = this.opportunities.filter(opp => opp.Confidential_Opportunity_c)?.length;
      if (confOpportunitiesCount != 0) {
        if (confOpportunitiesCount === this.opportunities.length) {
          return 'noOpportunityAccessCIQ';
        } else {
          this.opportunities = this.opportunities.filter(opp => opp.Confidential_Opportunity_c !== true);
          return 'noOpportunityAccessPartialCIQ';
        }
      }
    }

    return '';
  }

  ngOnDestroy(): void {
    /* required by angular-l10n */
  }
}
/**
 * Use cases for linking opportunities
 * 1)  when CIQ is down then show message "Integrated system is currently unavailable. Please try again later."  Link / Create opportunity would be disabled.
 * 2)  when user does not have access to CIQ  then show message "You do not have access/permission to view the opportunities (CIQ/Salesforce)". Link / Create opportunity would be disabled.
 * 3) when no opportunities linked to the leaseid then show message "No opportunities linked to this lease." (Show message instead of -)
 * 4) when linked opportunities are confidential  then show message "You do not have access/permission to view the opportunities (CIQ/Salesforce)"  ("Confidential_Opportunity_c":True). All linked opportunities are confidential.
 * 5) when user does not have access to confidential but has access to other opportunities then show message " You are not viewing all opportunities associated with this lease because of access restrictions. Please  contact your manager"    *{}Old message we implemented as part of a story needs to be replaced by this message{}*
 * 6) when user confidentiality is lower than lease record or if record is flagged as private then show message "You do not have complete access to lease or the record is private". Link / Create opportunity would be disabled.
 */
